export const MapReportTitle = {
  periodic368Days: "Periodic Inspection Report 368 Days",
  periodic184Days: "Periodic Inspection Report 184 Days",
  periodic92Days: "Periodic Inspection Report 92 Days",
  AirBrakeAFMLevelOne: "AirBrake Inspection Report Level 1",
  AirBrakeSys1Lvl2: "AirBrake Inspection Report System 1 Level 2",
  AirBrakeSys2Lvl2: "AirBrake Inspection Report System 2 Level 2",
  AirBrakeSys3Lvl2: "AirBrake Inspection Report System 3 Level 2",
  AirBrakeSys4Lvl2: "AirBrake Inspection Report System 4 Level 2",
  AirBrakeSys1Lvl3: "AirBrake Inspection Report System 1 Level 3",
  AirBrakeSys2Lvl3: "AirBrake Inspection Report System 2 Level 3",
  AirBrakeSys3Lvl3: "AirBrake Inspection Report System 3 Level 3",
  AirBrakeSys4Lvl3: "AirBrake Inspection Report System 4 Level 3",
  LocomotiveEngineOEMAssetAppForm: "Locomotive Engine OEM Report",
  eventRecordMicroprocessorTest27c: "Event Recorder Inspection Report",
  eventRecordTest25d: "Event Recorder Inspection Report",
  handBreakTest105c: "Handbrake Inspection Report",
  LocomotiveEngineOEMAssetAppForm: "Locomotive Engine OEM Report",
  emdPrimeMoverInspection: "EMD PRIME MOVER INSPECTION (368 DAYS)",
  GandO368Days: "G&O REQUIRED ITEMS",
};



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/Periodic/mapSchema.jsx